import { findingSortMethod_Alphabet, findingSortMethod_BySystem, findingSortMethod_Static, findingSortMethod_Timestamp } from './types.js';
export const findingSortMethod_LabelMap = {
    [findingSortMethod_Static]: 'Static',
    [findingSortMethod_Alphabet]: 'Alphabet',
    [findingSortMethod_Timestamp]: 'Timestamp',
    [findingSortMethod_BySystem]: 'By System',
};
export const findingSortMethod_InfoMap = {
    [findingSortMethod_Static]: 'Items are kept in the order they are gotten.',
    [findingSortMethod_Alphabet]: 'Items are sorted alphabetically.',
    [findingSortMethod_Timestamp]: 'Items are sorted based on timestamp, newer items first.',
    [findingSortMethod_BySystem]: 'Items are sorted based on the system tags, then internally by timestamp. Only relevant for flat rendering',
};
//# sourceMappingURL=consts.js.map